import { ChevronIcon } from '../../blocks/svg-elements/chevron-icon';
export default {
  name: 'PoSummaryItem',
  props: ['poData'],
  data() {
    return {
      isExpanded: this.poData?.expanded,
      poNumber: this.poData?.poNumber
    };
  },
  components: {
    ChevronIcon
  },
  computed: {
    displayFee() {
      return this.poData?.totalsByCurrency?.some(total => total.fee && total.fee != '0.00');
    },
    displayDiscount() {
      return this.poData?.totalsByCurrency?.some(total => total.discount && total.discount != '0.00');
    },
    displaySurcharge() {
      return this.poData?.totalsByCurrency?.some(total => total.surcharge && total.surcharge != '0.00');
    }
  },
  methods: {
    getLabel: function (key) {
      return window.Granite.I18n.get(key);
    },
    toggleDropdowns() {
      this.$emit('resetToggle', this.poNumber);
    },
    toggleIsExpanded() {
      this.isExpanded = !this.isExpanded;
    }
  }
};